import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";

import type { IDomain } from "../MarketBuilder.types";

export const getMissingDomainFavicons = async (selectedDomains: IDomain[]) => {
    const domainsWithoutIcons = selectedDomains.filter((entity) => !entity.favicon).map((entity) => entity.domain);

    return domainsWithoutIcons.length > 0 ? await fetchWebsitesFaviconsQuery(domainsWithoutIcons) : {};
};
